import Avatar from './components/Avatar';
import React, { useEffect, useState } from 'react';

const Clans = ({ setCurrentPage, setSelectedClan, formatNumber }) => {
  const [topClans, setTopClans] = useState([]);
  const [searchTag, setSearchTag] = useState('');
  const [searchError, setSearchError] = useState('');

  // Загрузка топ кланов
  useEffect(() => {
    const fetchTopClans = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/clans/top`);
        if (!response.ok) {
          throw new Error('Ошибка при загрузке топа кланов');
        }
        const data = await response.json();
        setTopClans(data);
      } catch (error) {
        console.error('Ошибка при загрузке топа кланов:', error);
      }
    };

    fetchTopClans();
  }, []);

  // Обработчик поиска клана по тэгу
  const handleSearchClan = async () => {
    if (!searchTag.trim()) {
      setSearchError('Введите тэг клана!');
      return;
    }

    try {
      const normalizedTag = searchTag.trim().replace(/^#/, '');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/clans/tag/${encodeURIComponent(normalizedTag)}`);
      if (!response.ok) {
        throw new Error('Клан с таким тэгом не найден');
      }

      const clanData = await response.json();
      setSelectedClan(clanData.id); // Устанавливаем ID найденного клана
      setCurrentPage('clans_info'); // Переход на страницу информации
    } catch (error) {
      console.error('Ошибка поиска клана:', error);
      setSearchError('Клан с таким тэгом не найден.');
    }
  };

  return (
<div className="container_ clans-main-page">
  {/* Заголовок Топ кланов */}
  <h1 className="section-title">🏆 Топ кланов</h1>

  {topClans.length === 0 ? (
    <p className="no-clans-message">Кланы ещё не созданы или данные недоступны.</p>
  ) : (
    <div className="clans-list">
      {topClans.slice(0, 3).map((clan, index) => (
        <div
          className={`clan-card rank-${index + 1}`}
          key={clan.id}
          onClick={() => {
            setSelectedClan(clan.id); // Передаем объект клана
            setCurrentPage('clans_info'); // Переход на страницу клана
          }}
        >
          <Avatar clanId={clan.id}
            src={clan.avatar_url || '/assets/imgur/C3a3S1X.png'}
            alt={`${clan.name} аватар`}
            className="clan-avatars"
            onError={(e) => (e.target.src = '/assets/imgur/C3a3S1X.png')} />
          <div className="clan-infos">
            <h2 className="clan-names">{clan.name}</h2>
            <p className="clan-memberss">{clan.member_count}/20 участников</p>
          </div>
          <div className="clan-trophies">
            <span className="trophy-icon">🏆</span>
            <span className="clan-points">{formatNumber(clan.total_clicks)}</span>
          </div>
        </div>
      ))}
    </div>
  )}

  {/* Вступить в клан */}
  <h1 className="section-title">Вступите в клан</h1>
  <div className="join-clan">
    <div className="join-by-tag">
      <div className="tag-input-container">
        <span className="tag-symbol">#</span>
        <input
          type="text"
          className="tag-input"
          placeholder="Введите тэг клана"
          value={searchTag}
          onChange={(e) => {
            setSearchError('');
            setSearchTag(e.target.value);
          }}
        />
        <button className="search-button" onClick={handleSearchClan}>
          ✔
        </button>
      </div>
      {searchError && <p className="error-message">{searchError}</p>}
    </div>
    <button className="view-list-button" onClick={() => setCurrentPage('clan_list')}>
      🔍 Найти в списке
    </button>
  </div>

  {/* Создать клан */}
  <h1 className="section-title">или создайте свой!</h1>
  <div className="create-clan">
    <button className="create-button" onClick={() => setCurrentPage('clan_add')}>
      <div className="create-content">
        <p>Создать клан!</p>
        <p className="clan-cost">-500.000</p>
      </div>
    </button>
  </div>
</div>

  );
};

export default Clans;
